import { useQuery } from '@tanstack/react-query';
import { Action, Subject } from '@erp/authz';
import { rpcClient } from 'src/api/rpc/client';
import { useCan } from 'src/hooks/useCan';

/**
 * Derived automation score for one task (`tasks.getAutomation`): autonomy +
 * intervention rates with per-checklist-item facts, recomputed server-side
 * from audit history on every read (nothing persisted).
 */
export function useTaskAutomation(taskId: string | null | undefined) {
  const [canReadTasks] = useCan(Action.Read, Subject.Task);
  return useQuery({
    queryKey: ['task-automation', taskId],
    queryFn: () => rpcClient.tasks.getAutomation({ id: taskId ?? '' }),
    enabled: canReadTasks && !!taskId,
  });
}

/**
 * Aggregate automation stats over the closed root tasks of one task type
 * (`tasks.automationStats`). Drives the queue page's stat strip when a
 * single type filter is active.
 */
export function useTaskAutomationStats(taskTypeKey: string | null | undefined) {
  const [canReadTasks] = useCan(Action.Read, Subject.Task);
  return useQuery({
    queryKey: ['task-automation-stats', taskTypeKey],
    queryFn: () =>
      rpcClient.tasks.automationStats({ taskTypeKey: taskTypeKey ?? '' }),
    enabled: canReadTasks && !!taskTypeKey,
  });
}
